import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import SmartStudyLineChart from "../../components/smart/StudyLineChart/StudyLineChart";
import ProfileCard from "../../components/ui-library/ProfileCard/ProfileCard";
import SmartPageHeader from "../../components/smart/PageHeader/PageHeader";
import StudyEntriesDatepicker from "../../components/smart/StudyEntriesDatepicker/StudyEntriesDatepicker";
import StudyEntriesTable from "../../components/smart/StudyEntriesTable/StudyEntriesTable";
import SmartTargets from "../../components/smart/Targets/Targets";
import { mapStateToPropsLogin } from "../../modules/login";
import { useTranslation } from "react-i18next";

const PanelsWrapper = styled.div`
  margin-left: 0px;
  margin-right: 0px;
  display: flex;

  @media (max-width: 1450px) {
    flex-direction: column;
  }
`;

const TargetsWrapper = styled.div`
  display: flex;
  margin-bottom: 15px;
  min-width: 400px;
  flex: 0;

  @media (max-width: 1024px) {
    min-width: 375px;
  }

  @media (max-width: 374px) {
    min-width: 320px;
  }
`;

const ChartWrapper = styled.div`
  display: flex;
  margin-bottom: 15px;
  min-width: 375px;
  margin-left: 20px;
  flex: 1;

  @media (max-width: 1450px) {
    margin-left: 0px;
  }

  @media (max-width: 374px) {
    min-width: 320px;
  }
`;

const Stats = (props) => {
  const {
    route: { study },
    match: {
      params: { participantId },
    },
    userData,
    studyEntriesDatePicker: { formattedDateRange = undefined } = {},
    loginReducer: { studies },
    canViewTargetPanel,
    canViewNutrientChart,
    canViewEntriesTable,
  } = props;

  const { t } = useTranslation();

  const [update, setUpdate] = useState(false);

  useEffect(() => {
    if (update) {
      setUpdate(false);
    }
  }, [update]);

  return (
    <>
      <SmartPageHeader
        title={studies && studies[0]?.code}
        participantId={participantId}
        shouldFetchParticipant={true}
        studyId={study}
      />

      <StudyEntriesDatepicker
        {...{ study }}
        {...{ participantId }}
        dateRange={formattedDateRange}
      />

      <PanelsWrapper>
        {canViewTargetPanel && (
          <TargetsWrapper>
            <SmartTargets
              {...{ participantId }}
              update={update}
              dateRange={formattedDateRange}
              userData={userData}
            />
          </TargetsWrapper>
        )}

        {canViewNutrientChart && (
          <ChartWrapper>
            <ProfileCard
              title={t("appText.dietDiary.macronutrientsChart.title")}
              showIcon={false}
            >
              <SmartStudyLineChart
                {...{ study }}
                update={update}
                {...{ participantId }}
                dateRange={formattedDateRange}
              />
            </ProfileCard>
          </ChartWrapper>
        )}
      </PanelsWrapper>

      {canViewEntriesTable && (
        <div className="mt-3">
          <ProfileCard
            title={t("appText.dietDiary.entriesTable.title")}
            showIcon={false}
          >
            <StudyEntriesTable
              {...{ study }}
              {...{ participantId }}
              userData={userData}
              dateRange={formattedDateRange}
              onUpdate={() => setUpdate(true)}
            />
          </ProfileCard>
        </div>
      )}
    </>
  );
};

export default withTheme(
  connect((state) => {
    return {
      ...mapStateToPropsLogin(state),
      studyEntriesDatePicker: state?.studyEntriesDatePickerReducer,
      userData: state?.smartPageHeaderReducer,
      loginReducer: state?.loginReducer,
    };
  })(Stats)
);
